import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const DELETE_FILES_DRIVER_RESET = 'DELETE_FILES_DRIVER_RESET';
export const DELETE_FILES_DRIVER_LOADING = 'DELETE_FILES_DRIVER_LOADING';
export const DELETE_FILES_DRIVER_SUCCESS = 'DELETE_FILES_DRIVER_SUCCESS';
export const DELETE_FILES_DRIVER_REJECT = 'DELETE_FILES_DRIVER_REJECT';

//* ACTIONS ------------------------------------------------
export const deleteFilesDriverReset = () => ({ type: DELETE_FILES_DRIVER_RESET });
export const deleteFilesDriverLoading = () => ({ type: DELETE_FILES_DRIVER_LOADING });
export const deleteFilesDriverSuccess = (payload) => ({ type: DELETE_FILES_DRIVER_SUCCESS, payload });
export const deleteFilesDriverReject = (payload) => ({ type: DELETE_FILES_DRIVER_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const deleteFilesDriverRequest = async (data = {}, getState) => {
    const options = await withToken({
        method: Methods.DELETE,
        data,
    }, getState);
    return request(`/Providers/web/DeleteProviderDriverUploadFile/${data}`, options);
};